import type { ReactNode } from 'react'

import type { Locale } from '@app/api'
import {
  createI18nContextValue,
  I18nContext
} from '@app/utilities/i18n/provider'

export default function I18nProvider({
  children,
  locale
}: {
  children: ReactNode
  locale: Locale
}) {
  return (
    <I18nContext.Provider value={createI18nContextValue(locale)}>
      {children}
    </I18nContext.Provider>
  )
}
